
export enum PointOfInterestContentType {
  Unassigned = 'Unassigned',
  Generic = 'Generic',
  Hike = 'Hike'
}
